<template>
  <main>
    <section>
      <div class="align-content-center m-4">
        <div class="page_title" style="display: flex;justify-content: center;">
          <div>
            <h3 class="page_title" style="display: inline-block;
                  height: 4.1rem;
                  border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Leave Message </h3>
          </div>
        </div>
      </div>
      <div class="col-md-6 m-3 page_search">

      </div>
    </section>
    <!-- <section class="container pt-5 pb-5">
      <div class="container content_padding text-white">
        <h4 class="pb-5">Leave A Message</h4>
        <div class="row">
          <textarea style="background-color: #2D2D2C;" placeholder="Please enter the message content..."></textarea>
          <div class="col-md-12 pt-4 text-center">
            <button class="btn custom-btn-primary " style="padding: 0.6rem 3rem;border-radius: 5px;">Submit</button>
          </div>
        </div>
      </div>
    </section> -->
    <section>
      <el-row>
        <el-col style="background-color: #434343;"> 
          <section style="text-align: right;padding-right: 13%;height: 36px;line-height: 36px;margin-right: 2px;">
            <el-button type="primary" size="mini" style="width: 80px;" @click="openDialog(null)">Message</el-button>
          </section>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <table>
            <tr>
              <td class=" col-md-1-1" style="vertical-align: top; padding: 0;background-color: #1D1D1B;">
                <div class="tree-box" style="width: 100%;min-width: 240px;">
    
                  <div class="tree-content" style="padding-top: 16px;">
                    <el-tree ref="treeleft" :data="treeData" node-key="id" :indent="0" class="tree-line"
                      :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                      @cell-style="{color:red}" :default-expand-all="isLeftExp" :highlight-current="false"
                      :expand-on-click-node="false">
                      <span slot-scope="{ data }" class="custom-tree-node">
                        <template>
                          <div class="node_div">
                            <span class="name-box">
                              {{ data.name }} <span v-if="data.name=='2025 Year'" style="color: #F3AD2C;">(1)</span>
                            </span>
                          </div>
                        </template>
                      </span>
                    </el-tree>
                  </div>
                </div>
              </td>
              <td class="container col-md-10-1"
                style="vertical-align: top;padding: 0;">
                <section style="width: 100%;padding-left: 10%;padding-right: 15%;">
                  <div class="px-3 pt-3" style="border: 1px solid #454544;width: 100%;border-top: none;">
                    <div class="row item_message col-md-12">
                      <div class="row col-md-12">
                        <h6 class="col-md-9 text-left">2024-11-27：</h6>
                        <span class="col-md-12 text-left text-muted user_message">
                          Hello! Our company is looking for high-quality
                          automotive lighting suppliers.
                          <br> Please reply at your convenience 
                          so that we can further discuss the
                          details
                          of cooperation.
                        </span>
                      </div>
    
                      <div class="row mt-2 col-md-12 pl-4 mt-4 ">
                        <h6 class="col-md-9 text-left">Admin：</h6>
                        <p class="col-md-3 text-right text-muted">2024-11-27 15:20:00</p>
                        <p class="col-md-12 text-left text-muted user_message">
                          Thank you!
                        </p>
                      </div>
                      <div class="col-md-12 text-right" style="display: inline;">
                        <el-button type="primary" size="mini" style="font-size: 10px;height: 25px;"  @click="aaa" >Reply</el-button>
                        <el-button type="primary" size="mini" style="font-size: 10px;height: 25px;"  @click="bbb" >Delete</el-button>
                        <!-- <el-row>
                          <el-col><img src="/assets/img/About/message.png" style="width: 20px; height: 20px;"></el-col>
                          <el-col>
                            <a href="">删除</a>
                          </el-col>
                        </el-row> -->
                        
                      </div>
                    </div>
                    <hr>
    
    
                    <div class="row item_message col-md-12">
                      <div class="row col-md-12">
                        <h6 class="col-md-9 text-left">TechLight_Wizard：</h6>
                        <p class="col-md-3 text-right text-muted">2024-11-27 15:20:00</p>
                        <p class="col-md-12 text-left text-muted user_message">
                          I sent you a private message
                        </p>
                      </div>
                      <div class="col-md-12 text-right">
                        <img src="/assets/img/About/message.png" style="width: 20px; height: 20px;">
                      </div>
                    </div>
                    <hr>
                    <div class="row item_message col-md-12">
                      <div class="row col-md-12">
                        <h6 class="col-md-9 text-left">AutoGlow_Guru：</h6>
                        <p class="col-md-3 text-right text-muted">2024-11-27 15:20:00</p>
                        <p class="col-md-12 text-left text-muted user_message">
                          I am very interested in your company's recent
                          products. 
                          <br>I would like to know the specific performance, price, and delivery time of these
                          products.
                          <br>
                          Looking forward to your reply, thank you!
                        </p>
                      </div>
                      <div class="col-md-12 text-right">
                        <img src="/assets/img/About/message.png" style="width: 20px; height: 20px;">
                      </div>
                    </div>
                    <hr>
                    <div class="row item_message col-md-12">
                      <div class="row col-md-12">
                        <h6 class="col-md-9 text-left">User 12015236491:</h6>
                        <p class="col-md-3 text-right text-muted">2024-11-27 15:20:00</p>
                        <p class="col-md-12 text-left text-muted user_message">
                          Your company's lights are of good quality and we are
                          interested in cooperating with you. Please reply and discuss in detail
                        </p>
                      </div>
                      <div class="col-md-12 text-right">
                        <img src="/assets/img/About/message.png" style="width: 20px; height: 20px;">
                      </div>
                    </div>
                    <hr>
                    <div class="row item_message col-md-12">
                      <div class="row col-md-12">
                        <h6 class="col-md-9 text-left">Luminary_Voyager：</h6>
                        <p class="col-md-3 text-right text-muted">2024-11-27 15:20:00</p>
                        <p class="col-md-12 text-left text-muted user_message">
                          I am very satisfied with your company’s lights and
                          after-sales service. Look forward to more new products from you
                        </p>
                      </div>
                      <div class="col-md-12 text-right">
                        <img src="/assets/img/About/message.png" style="width: 20px; height: 20px;">
                      </div>
                    </div>
                  </div>
                </section>
              </td>
            </tr>
          </table>
        </el-col>
      </el-row>
     

    </section>


  </main>
</template>

<script>
  export default {
    name: 'Leave',

    data() {
      return {
        treeData: [{
          id: 1, name: 'News', value: 0, children: [{ id: 2, name: '2023 Year', value: 2023 }, { id: 3, name: '2024 Year', value: 2024 }, { id: 4, name: '2025 Year', value: 2025 }]
        }],
        isLeftExp: true,
      };
    },
    methods: {

    },
  };
</script>
<style scoped>
  @import '../../assets/css/main.css';

  .tree-line {
    background-color: transparent;
    color: #D3D3D2;
    min-height: 100vh;
  }
  :deep(textarea) {
    width: 100%;
    padding: 15px;
    font-size: 14px;
    background-color: #F6F6F6;
    height: 16rem;
    border: none;
    /* 默认边框 */
    border-radius: 5px;
    resize: none;
    /* 禁用拖动大小 */
    box-sizing: border-box;
    outline: none;
    /* 移除默认聚焦样式 */
    transition: border-color 0.3s ease;
  }

  :deep(textarea:hover,
    textarea:focus) {
    border: none;
    box-shadow: none;
  }

  :deep(.item_message) {
    padding-bottom: 1rem;
    border-bottom: 1px solid #6C6C6C;

  }

  :deep(.user_message) {
    padding: 1rem 0;
    line-height: 1.2rem;
  }

  :deep(.message_reply) {
    border-left: 1px solid #6C6C6C;
  }
</style>